import { render, staticRenderFns } from "./lpMobile.vue?vue&type=template&id=63c38262"
import script from "./lpMobile.vue?vue&type=script&lang=js"
export * from "./lpMobile.vue?vue&type=script&lang=js"
import style0 from "./lpMobile.vue?vue&type=style&index=0&id=63c38262&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports